/**
 * Stats feature hooks — React Query wrappers.
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import { statsApi, backendApi } from './api'

// ── Dashboard ─────────────────────────────────────────────────────────

export function useDashboardStats() {
    return useQuery({
        queryKey: ['stats', 'dashboard'],
        queryFn: async () => {
            const res = await statsApi.getDashboardStats()
            return res.data
        },
    })
}

// ── Backend Management ────────────────────────────────────────────────

export function useSystemStatus() {
    return useQuery({
        queryKey: ['stats', 'backend', 'system-status'],
        queryFn: async () => {
            const res = await backendApi.getSystemStatus()
            return res.data
        },
    })
}

export function useDatabaseConnection() {
    return useQuery({
        queryKey: ['stats', 'backend', 'connection', 'database'],
        queryFn: async () => {
            const res = await backendApi.getDatabaseConnection()
            return res.data
        },
    })
}

export function useAiConnection() {
    return useQuery({
        queryKey: ['stats', 'backend', 'connection', 'ai'],
        queryFn: async () => {
            const res = await backendApi.getAiConnection()
            return res.data
        },
    })
}

export function useSmtpConnection() {
    return useQuery({
        queryKey: ['stats', 'backend', 'connection', 'smtp'],
        queryFn: async () => {
            const res = await backendApi.getSmtpConnection()
            return res.data
        },
    })
}

export function useSystemMetrics() {
    return useQuery({
        queryKey: ['stats', 'backend', 'system-metrics'],
        queryFn: async () => {
            const res = await backendApi.getSystemMetrics()
            return res.data
        },
    })
}

export function useDatabaseStatus() {
    return useQuery({
        queryKey: ['stats', 'backend', 'database-status'],
        queryFn: async () => {
            const res = await backendApi.getDatabaseStatus()
            return res.data
        },
    })
}

export function useRefreshSystemStatus() {
    return useMutation({
        mutationFn: () => backendApi.refreshSystemStatus(),
    })
}

export function useHealthCheck() {
    return useQuery({
        queryKey: ['stats', 'backend', 'health'],
        queryFn: async () => {
            const res = await backendApi.getHealthCheck()
            return res.data
        },
        refetchInterval: 60000, // Check every minute
    })
}
